window.addEventListener('load', function () {

  function dispatchResize() {
    var resizeEvent = window.document.createEvent('UIEvents');
    resizeEvent.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(resizeEvent);
    window.dispatchEvent(new Event('resize'));
    console.log('resize')
  }

  var Drawer__Upsell_wrapper = document.querySelector('#old-upsell');
  if (window.theme.Drawer__Upsell) {
    console.log(Drawer__Upsell_wrapper)
    Drawer__Upsell_wrapper.style.display = 'block';
    dispatchResize();
  }

  function checkUpsell() {
    //check if upsell item applicable added 
    console.log('product updates ');
    var upsell_flag = false, upsell_sandal_flag = false, upsell_bag_flag = false, upsell_other_flag = false;
    var hidden_items = 0, hidden_items_sandals = 0, hidden_items_bags = 0, hidden_items_other = 0;
    var slider_cells = document.querySelectorAll('#old-upsell .Carousel__Cell');
    //show all hidden cells up front 
    for (var i = 0; i < slider_cells.length; i++) {
      slider_cells[i].style.display = 'block';
    }
    setTimeout(function () { dispatchResize() }, 800);
    fetch('/cart.js')
      .then((response) => response.json())
      .then(function (e) {
        let items_size = e.items.length;
        window.theme.Drawer__Upsell_type = null;
        for (var i = 0; i < items_size; i++) {

          var cart_item_upsell_check = document.querySelector('#old-upsell .Carousel__Cell[upsell-variant="' + e.items[i].id + '"]');
          console.log("id", e.items[i].id);
          if (cart_item_upsell_check) {
            console.log('cart_item_upsell_check', cart_item_upsell_check)
            cart_item_upsell_check.style.display = 'none';

            if (e.items[i].properties && e.items[i].properties['upsell-type'] == 'upsell-sandal') {
              console.log('sandals');
              hidden_items_sandals++;
            } if (e.items[i].properties && e.items[i].properties['upsell-type'] == 'upsell-bag') {
              hidden_items_bags++;
              console.log('bag');
            } else {
              hidden_items_other++;
              console.log('other');
            }
            dispatchResize();
          }

          if (i == items_size || window.theme.Drawer__Upsell_type == null) {
            console.log('properties ', e.items[i].properties, i, items_size);
            if (e.items[i].properties && e.items[i].properties['upsell'] == 1) {
              window.theme.Drawer__Upsell_type = 'sandals-only';
            }
            else if (e.items[i].properties && e.items[i].properties['upsell'] == 2) {
              window.theme.Drawer__Upsell_type = 'bags-only';
            }
            else if (e.items[i].properties && e.items[i].properties['upsell'] == 3) {
              window.theme.Drawer__Upsell_type = 'other-only';
            } else {
              window.theme.Drawer__Upsell_type = null;
            }
          }


        }//endfor

        if (window.theme.Drawer__Upsell_type != null)
          upsell_flag = true;

        if (window.theme.Drawer__Upsell_type == null) {
          Drawer__Upsell_wrapper.style.display = 'none';
          window.theme.Drawer__Upsell = false;
          return;
        }

        hidden_items = (window.theme.Drawer__Upsell_type.indexOf('sandals') > -1) ? hidden_items_sandals : ((window.theme.Drawer__Upsell_type.indexOf('bags') > -1) ? hidden_items_bags : hidden_items_other);

        var item_types = (window.theme.Drawer__Upsell_type.indexOf('sandals') > -1) ? 'upsell-sandal' : (window.theme.Drawer__Upsell_type.indexOf('bags') > -1) ? 'upsell-bag' : 'upsell-other';

        var items_number = Drawer__Upsell_wrapper.querySelectorAll('.Carousel__Cell.' + item_types).length;
        //  if(!upsell_sandal_flag || upsell_bag_flag){
        //    items_number = Drawer__Upsell_wrapper.querySelectorAll('.Carousel__Cell.upsell-bag').length;
        //    hidden_items = hidden_items_bags;
        //  }

        console.log('hidden_items ', items_number, hidden_items, hidden_items_bags, hidden_items_sandals, hidden_items_other);

        if (hidden_items == items_number) {
          Drawer__Upsell_wrapper.style.display = 'none';
          window.theme.Drawer__Upsell = false;
          return;
        } else {
          Drawer__Upsell_wrapper.style.display = 'block';
          window.theme.Drawer__Upsell = true;
        }

        if ((items_number - hidden_items) == 2) {
          Drawer__Upsell_wrapper.querySelector('.products-list').classList.add('tow-items');
          dispatchResize();
        }
        else if ((items_number - hidden_items) == 1) {
          document.querySelector('.Drawer__Upsell .products-list').classList.add('one-item');
          dispatchResize();
        }
        else {
          if (document.querySelector('.Drawer__Upsell .products-list').className.indexOf('tow-items') > -1)
            document.querySelector('.Drawer__Upsell .products-list').classList.remove('tow-items');
          if (document.querySelector('.Drawer__Upsell .products-list').className.indexOf('one-item') > -1)
            document.querySelector('.Drawer__Upsell .products-list').classList.remove('one-item');
        }

        // //check UPSELL type items
        // if( (window.theme.Drawer__Upsell_SANDAL && upsell_sandal_flag) || 
        //     (!window.theme.Drawer__Upsell_SANDAL && upsell_sandal_flag) ){
        //     document.querySelector('.Drawer__Upsell .products-list').classList.remove('bags-only');
        //     document.querySelector('.Drawer__Upsell .products-list').classList.add('sandals-only');
        // }else{
        //     document.querySelector('.Drawer__Upsell .products-list').classList.remove('sandals-only');
        //     document.querySelector('.Drawer__Upsell .products-list').classList.add('bags-only');
        // }

        // display the first item type category 
        document.querySelector('#old-upsell .products-list').classList.remove('sandals-only');
        document.querySelector('#old-upsell .products-list').classList.remove('bags-only');
        document.querySelector('#old-upsell .products-list').classList.remove('other-only');
        document.querySelector('#old-upsell .products-list').classList.add(window.theme.Drawer__Upsell_type);

        dispatchResize();

        console.log(upsell_flag, window.theme.Drawer__Upsell)
        if (upsell_flag && !window.theme.Drawer__Upsell) {
          window.theme.Drawer__Upsell = true;
          Drawer__Upsell_wrapper.style.display = 'block';
          dispatchResize();
        } else if (!upsell_flag && window.theme.Drawer__Upsell) {
          window.theme.Drawer__Upsell = false;
          Drawer__Upsell_wrapper.style.display = 'none';
        }

      });
    //  });

  }

  document.addEventListener('product:added', checkUpsell, false);
  document.addEventListener('product:changed', checkUpsell, false);
  document.addEventListener('cart:updated', checkUpsell, false);

  var add_upsell_buttons = document.querySelectorAll('.upsell-add');
  console.log('add_upsell_buttons ', add_upsell_buttons.length)
  for (var i = 0; i < add_upsell_buttons.length; i++) {
    add_upsell_buttons[i].addEventListener('click', function (e) {
      var target = e.target;
      console.log(e.target.tagName)
      if (e.target.tagName != 'DIV')
        return;
      var id = target.dataset.variant_id,
        type = target.dataset.type,
        revenu = target.dataset.value;
      if (!id)
        return;
      var addToCartButton = e.target;
      addToCartButton.setAttribute('disabled', true);
      //update analytics
      console.log('GA plus clicked')
      if (typeof ga !== "undefined") {
        ga('send', {
          hitType: 'event',
          eventCategory: 'Upsell',
          eventAction: 'Plus Clicked',
          nonInteraction: true,
          eventValue: revenu
        });
      }
      //update cart
      fetch('/cart/add.js', {
        body: JSON.stringify({
          items: [{
            id: id,
            quantity: 1,
            properties: {
              "upsell-item": true,
              'upsell-type': type
            }
          }]
        }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        }
      }).then(function (response) {

        if (response.ok) {
          addToCartButton.removeAttribute('disabled');
          // We simply trigger an event so the mini-cart can re-render
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: id,
              quantity: 1
            }
          }));

        } else {
          response.json().then(function (content) {
            var errorMessageElement = document.createElement('span');
            errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
            errorMessageElement.innerHTML = content['description'];
            addToCartButton.removeAttribute('disabled');
            addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
          });
        }

      });

    })
  }

});